// extracted by mini-css-extract-plugin
export default {"mainContainer":"TimeReminderModal_mainContainer__6tfQt","buttonContainer":"TimeReminderModal_buttonContainer__UZeAm"};